import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';
import { useToast, useToasts } from '@/components/ui/use-toast';

/** Mount once near the root (see app/providers.tsx). */
export function Toaster() {
  const toasts = useToasts();
  const { dismiss } = useToast();

  return (
    // App is RTL: the visual "end" edge is the physical left side.
    <ToastProvider swipeDirection="left" duration={5000}>
      {toasts.map(({ id, title, description, variant }) => (
        <Toast key={id} variant={variant} onOpenChange={(open) => !open && dismiss(id)}>
          <div className="flex flex-col gap-1">
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && <ToastDescription>{description}</ToastDescription>}
          </div>
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}
